import React from "react";
import Swal from "sweetalert2";
import axios from "axios";

const EditSubAssembly = ({ isOpen, onClose, editFormData, setEditFormData, id }) => {
  if (!isOpen) return null;

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleEditSubmit = async (e) => {
  e.preventDefault();

  // 🔹 Validation for Sub Assembly
  if (!editFormData.sa || editFormData.sa.trim() === "") {
    Swal.fire({
      icon: "warning",
      title: "Empty Field",
      text: "Please enter Sub Assembly!",
    });
    return;
  }

  try {
    Swal.fire({
      title: "Submitting...",
      text: "Please wait while we process your request.",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    const response = await axios.put(`https://rfs2.infraconsoft.net.in/api/edit_sub_assembly_api`, {
      sa: editFormData.sa,
      subId: editFormData.subId,
      id: id
    });

    if (response.data.success) {
      Swal.fire({
        icon: "success",
        title: "Updated!",
        text: "Sub Assembly updated successfully.",
      });
      onClose();
      window.location.reload();
    } else {
      Swal.fire({
        icon: "error",
        title: "Update Failed",
        text: response.data.message || "Unknown error.",
      });
    }

  } catch (error) {
    console.error("Error Update:", error);

    if (error.response) {
      console.error("Error Response Data:", error.response.data);
    }

    if (error.response && error.response.data && error.response.data.message) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.response.data.message,
      });
    } else {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Update failed. Please try again.",
      });
    }
  }
};


  return (
    <div className="modal">
      <div className="modal-content" style={{ position: "relative" }}>
      <div style={{ position: "absolute", top: "10px", right: "10px" }}>
        <button className="close-btn" onClick={onClose} style={{position: "initial"}}>&times;</button>
    </div>
        <h3>Edit Sub Assembly</h3>
        <form className="vehicle-form" onSubmit={handleEditSubmit}>

            <div className="form-row">
            <div className="form-group">
                <label>Sub Assembly :</label>
                <input
            type="text"
            name="sa"
            value={editFormData.sa}
            onChange={handleEditChange}
          />
              </div>
              
            </div>

            <div className="btn-cls">
              <button type="submit" className="submit-btn">
                 Update
              </button>
            </div>
           
            </form>

      </div>
    </div>
  );
};

export default EditSubAssembly;
